/**
 * FAR access helpers shared by the Send page, Extensions and the Rules page.
 */
import { FAR_EXTENSION_KEY } from "../../../../assets/js/utils/far/farEngine";
import { isFarMockMode } from "../../../../assets/js/utils/far/farApi";

/** True when the File Attachment Rules extension is switched on for this user's organization. */
export const isFarEnabled = (user) => {
    if(isFarMockMode()){
        return true;
    }
    try{
        const extension = user && user.extensions ? user.extensions[FAR_EXTENSION_KEY] : null;
        return !!(extension && (extension.status === true || extension.status === 1 || extension.status === "1"));
    }catch(e){ }
    return false;
};

/** Employees of a business account are not administrators (same check as Extensions.js). */
export const isFarAdmin = (user) => {
    if(!user){
        return false;
    }
    const isEmployee = user.hasOwnProperty("businessUser") && user.businessUser !== null && user.member_type !== "business";
    return !isEmployee;
};
